var $          = require('jquery');
var elementary = require('../vendor/elementary.js');

var Pagination = {
	trigger: $('[data-pagination-trigger]'),
	target: $('[data-pagination-target]'),
	loadingClass: 'is-loading',
	ajaxUrl: null,
	perPage: null,
	category: null,
	offset: 0,

	init: function() {
		if (Pagination.trigger.length) {
			// Get data attrs on trigger
			Pagination.ajaxUrl = Pagination.trigger.data('paginationUrl');
			Pagination.perPage = Pagination.trigger.data('paginationPerPage');
			Pagination.category = Pagination.trigger.data('paginationCategory') ? Pagination.trigger.data('paginationCategory') : null;

			Pagination.trigger.on('click', Pagination.loadItemsOnClick);
			Pagination.loadItems();
		}
	},

	loadItemsOnClick: function(e) {
		e.preventDefault();
		Pagination.loadItems();
	},

	loadItems: function() {
		Pagination.trigger.addClass(Pagination.loadingClass);

		var postData = {
			offset: Pagination.offset,
			limit: Pagination.perPage
		};

		if (Pagination.category) {
			postData['category'] = Pagination.category;
		} 

		$.post(Pagination.ajaxUrl, postData)
			.done(function(data) {

				// If html has been returned...
				if (data.html.length > 0) {
					// Add html to target
					Pagination.target.append(data.html);
					// Run elementary for new items
					elementary();

					// Fade in tile once tile image loaded
					$('.tile').not('.is-loaded').each(function(i) {
						var img = $(this).find('img');
						if ( img.length > 0 ) {
							img.on('load', function() {
								$(this).parent().addClass('is-loaded');
							});
						}
					});

					// Increase offset for next pagination call
					Pagination.offset = Pagination.offset + Pagination.perPage;

					if (history.pushState) {
						history.pushState(null, null, '?num=' + Pagination.offset);
					}
				} else {
					$('[data-pagination-noresults]').addClass('is-active');
				}

				// If there are no more entries to show 
				if (data.more === false) {
					Pagination.trigger.remove();
				}
			})
			.always(function() {
				Pagination.trigger.removeClass(Pagination.loadingClass);
			});
	}
};

export default Pagination;